// 基本参数
var CONFIG = {
     PERPAGE:10,
     URL: 'https://test.yizhiniao.com'
};

// 环境的切换
if (process.env.NODE_HOST == 'production') {
    CONFIG.URL = 'https://www.yizhiniao.com';
} else {
    CONFIG.URL = 'https://test.yizhiniao.com';
}

export default CONFIG;



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 1